import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createCardBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/layoutBlockHelpers/cardBlockHelper";
import {
  createH2Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import supportImagePlaceholder from "../../CallToAction/CardCallToAction/support_image_placeholder.png";
import userImagePlaceholder from "../../CallToAction/CardCallToAction/user_image_placeholder.png";
import usersImagePlaceholder from "../../CallToAction/CardCallToAction/users_image_placeholder.png";
import checkBulletImage from "../../Content/UlListBlock/check_bullet.png";
import { getHomepageBlockSecondaryStyleOptions } from "../constants";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "HomepageBlock2",
  props: {
    header: {
      prop: "children",
      type: "children",
      value: [
        createH2Block({
          text: "Transform Your Leadership with Coaching & Community",
        }),
        createPBlock({
          text: "Get personalized coaching, participate in mastermind discussions, and connect with peers who challenge and support your growth.",
        }),
      ],
    },
    content: {
      prop: "children",
      type: "children",
      value: [
        createCardBlock({
          image: {
            signedId: "",
            placeholder: userImagePlaceholder,
          },
          h5Text: "1:1 Executive Coaching",
          pText:
            "Get a custom leadership roadmap tailored to YOUR career goals",
          ulList: [
            {
              text: "Step-by-step coaching delivers measurable results in 90 days",
              placeholder: checkBulletImage,
            },
            {
              text: "Strategic frameworks used by Fortune 500 executives",
              placeholder: checkBulletImage,
            },
            {
              text: "Bi-weekly accountability check-ins to ensure progress",
              placeholder: checkBulletImage,
            },
          ],
          description: "Only 5 spots available this month",
          button: {
            text: "Apply Now",
            href: "#",
          },
        }),
        createCardBlock({
          image: {
            signedId: "",
            placeholder: usersImagePlaceholder,
          },
          h5Text: "Leadership Mastermind",
          pText:
            "Solve your biggest challenges with guidance from peers who've been there",
          ulList: [
            {
              text: "Monthly facilitated sessions with leaders across industries",
              placeholder: checkBulletImage,
            },
            {
              text: "Hot seat format ensures YOUR challenges get solved",
              placeholder: checkBulletImage,
            },
            {
              text: "Build a network of high-performing peers",
              placeholder: checkBulletImage,
            },
          ],
          description: "Next cohort starts June 1st",
          button: {
            text: "Reserve Your Spot",
            href: "#",
          },
        }),
        createCardBlock({
          image: {
            signedId: "",
            placeholder: supportImagePlaceholder,
          },
          h5Text: "Community Support",
          pText: "Never feel alone in your leadership journey again",
          ulList: [
            {
              text: "24/7 access to our private leadership community",
              placeholder: checkBulletImage,
            },
            {
              text: "Weekly live Q&A sessions to solve urgent challenges",
              placeholder: checkBulletImage,
            },
            {
              text: "Exclusive resource library worth $5,000+",
              placeholder: checkBulletImage,
            },
          ],
          description: "Founding member pricing ends soon",
          button: {
            text: "Join Now",
            href: "#",
          },
        }),
      ],
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        ...getHomepageBlockSecondaryStyleOptions(),
      },
    },
  },
};
